import { render, staticRenderFns } from "./UserTile.vue?vue&type=template&id=40f82790&scoped=true&"
import script from "./UserTile.vue?vue&type=script&lang=js&"
export * from "./UserTile.vue?vue&type=script&lang=js&"
import style0 from "./UserTile.vue?vue&type=style&index=0&id=40f82790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f82790",
  null
  
)

export default component.exports